import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { SupportedLanguageCodes, } from '../i18n/translations';
import { log } from '../lib/logger';
import { IntlMessageFormat } from 'intl-messageformat';
export const useTextDir = (text) => {
    const { i18n } = useTranslation();
    const locale = useMemo(() => {
        const lang = i18n.language;
        if (SupportedLanguageCodes.includes(lang)) {
            return lang;
        }
        log.error('Unsupported language', lang);
        return 'en-US';
    }, [i18n.language]);
    const formattedMessage = useMemo(() => {
        try {
            const msg = text.replace(/</g, '&lt;');
            const result = new IntlMessageFormat(msg, locale).format();
            return Array.isArray(result)
                ? result.map(r => r.replace(/&lt;/g, '<'))
                : result.replace(/&lt;/g, '<');
        }
        catch (exc) {
            log.error(exc);
            return text;
        }
    }, [text, locale]);
    return { formattedMessage, dir: i18n.dir(locale) };
};
